<template>
  <div class="loginContainer">
    <dean-header :logo="headerLogo" logo-height="35"></dean-header>
    <dean-load-overlay></dean-load-overlay>
  </div>
</template>

<script lang="ts">
  import { Vue, Component } from 'vue-property-decorator';
  import { deanLoadOverlay, deanHeader } from '@deanone/dean-components';
  import { clearTokens } from '@/services/keycloak';

  /**
   * Keycloak only redirects here after the user has explicitly confirmed the
   * logout on Keycloak's own confirmation screen. If the user cancels that
   * screen instead, Keycloak never redirects back, so this component never
   * runs and the WS Portal session/tokens remain untouched.
   *
   * Local tokens and auth state are cleared here, and only here, to make
   * sure the WS Portal session is only invalidated once Keycloak's SSO
   * session has actually been terminated.
   */
  @Component({
    components: {
      deanLoadOverlay,
      deanHeader,
    },
  })
  export default class LogoutCallback extends Vue {
    get headerLogo() {
      return this.$store.getters.getTheme.data.loginLogo;
    }

    public created() {
      clearTokens();
      this.$store.commit('SET_IS_AUTHENTICATED', false);
      localStorage.layouts = JSON.stringify([]);

      this.$router.replace({ name: 'auth.login', query: { loggedOut: '1' } });
    }
  }
</script>
